import type { I18nFn } from 'i18n/types/I18nFn';

export function EXPECTED_TIMES(i18n: I18nFn) {
  return [
    {
      id: 'NONE',
      name: '',
    },
    {
      id: 'FEW_HOURS_MONTH',
      name:
        /* TRANSLATORS: expected time */
        i18n('A few hours per month'),
    },
    {
      id: 'FEW_HOURS_WEEK',
      name:
        /* TRANSLATORS: expected time */
        i18n('A few hours per week'),
    },
    {
      id: 'PART_TIME',
      name:
        /* TRANSLATORS: expected time */
        i18n('Part time (10-30 hrs/wk)'),
    },
    {
      id: 'FULL_TIME',
      name:
        /* TRANSLATORS: expected time */
        i18n('Full time (30+ hrs/wk)'),
    },
  ];
}
